import { render, staticRenderFns } from "./GeneratedFiles.vue?vue&type=template&id=4571a694&scoped=true"
import script from "./GeneratedFiles.vue?vue&type=script&lang=ts"
export * from "./GeneratedFiles.vue?vue&type=script&lang=ts"
import style0 from "./GeneratedFiles.vue?vue&type=style&index=0&id=4571a694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4571a694",
  null
  
)

export default component.exports